"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "furci-siculo": {
    "3f9f7e84": [{
      "hkey": "93e18c9d",
      "slug": "furci-siculo",
      "name": "Furci Siculo",
      "primary": true,
      "skipSearch": false
    }],
    "artale": [{
      "hkey": "93e18c9d",
      "slug": "furci-siculo",
      "name": "Furci Siculo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19a20a56": [{
      "hkey": "1d2eebe8",
      "slug": "calcare-grotte",
      "name": "Calcare-Grotte",
      "primary": true,
      "skipSearch": false
    }],
    "grotte-calcare": [{
      "hkey": "1d2eebe8",
      "slug": "calcare-grotte",
      "name": "Calcare-Grotte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;